{
  "colorSwatchPicker": "Barvne palete",
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Izberite element",
  "tableResizer": "Spreminjanje velikosti"
}
